import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Slider from 'react-slick';
//import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

import { withAppContext } from '../../contexts/app';
import { DesktopUp } from 'shared/Responsive';

import ImageUploader from '../../components/ImageUploader';

import FeatureSlide1 from 'images/ask/home/features/feature-slide1.png';
//import FeatureSlide2 from 'images/ask/home/features/feature-slide2.png';
//import FeatureSlide3 from 'images/ask/home/features/feature-slide3.png';
import ArrowIcon from 'images/ask/icons/arrow-01.svg';

class Features extends PureComponent {
  render() {
    const featureSliderSettings = {
      speed: 1000,
      autoplay: true,
      fade: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1
    };

    return (
      <section className="features" id="features">
        <div className="container">
          <h2>A dermatology tool in your pocket.</h2>

          <div className="feature-list-container">
            <DesktopUp>
              <Slider {...featureSliderSettings}>
                <img src={FeatureSlide1} />
                {/*
                <img src={FeatureSlide2} />
                <img src={FeatureSlide3} />
                */}
              </Slider>
            </DesktopUp>
            <div className="feature-list">
              <div className="feature results">
                <div className="feature__content">
                  <h3>Results</h3>
                  <p>
                    Get an instant differential of potential skin conditions.
                  </p>

                  <span className="link-with-icon">
                    <ImageUploader
                      label="Start your scan"
                      onUpload={this.onImageUpload.bind(this)}
                    />
                    <img src={ArrowIcon} />
                  </span>
                </div>
              </div>
              <div className="feature account">
                <div className="feature__content">
                  <h3>Personalized</h3>
                  <p>
                    Your results are determined from the photo you upload using advanced artificial intelligence.
                  </p>
                </div>
              </div>
              <div className="feature privacy">
                <div className="feature__content">
                  <h3>Privacy</h3>
                  <p>
                    Everything you share with Triage is confidential and stored securely.
                  </p>
                  <HashLink to="/terms#privacy_policy" className="link-with-icon">
                    <span>Our privacy policy</span>
                    <img src={ArrowIcon} />
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

Features.defaultProps = {};

Features.propTypes = {
  app: PropTypes.object.isRequired
};

export { Features };
export default withAppContext(Features);
